import { useEffect, useState } from "react";

// ** Custom Components
import CarouselBanner from "@components/banners/carousel-banner";
import HowItWorks from "./how-it-works";
import AppAd from "@components/app-ad";
import FacebookPosts from "./facebook-posts";

// ** Reactstrap Imports
import { Container, Button } from "reactstrap";

// ** Third party components
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

// ** Utils
import useFetch from "@hooks/useFetch";
import { isUserHasSolar } from "@utils";

const Home = () => {
  // ** States
  const { t } = useTranslation();
  const [homeData, setHomeData] = useState({
    how_it_works: [
      { order: 1, image: "", title: "", summary: "" },
      { order: 1, image: "", title: "", summary: "" },
      { order: 1, image: "", title: "", summary: "" },
    ],
    facebook_posts: [
      {
        id: 1,
        story: "",
        permalink_url: "",
        attachments: [
          {
            image: {
              height: 1,
              src: "",
              width: "",
            },
          },
        ],
      },
      {
        id: 1,
        story: "",
        permalink_url: "",
        attachments: [
          {
            image: {
              height: 1,
              src: "",
              width: "",
            },
          },
        ],
      },
      {
        id: 1,
        story: "",
        permalink_url: "",
        attachments: [
          {
            image: {
              height: 1,
              src: "",
              width: "",
            },
          },
        ],
      },
    ],
  });

  // ** Hooks
  const { response, fetchData, loading } = useFetch();
  const navigate = useNavigate();

  // ** Get data
  useEffect(() => {
    fetchData("/home");
  }, []);

  useEffect(() => {
    response && setHomeData(response.data.data);
  }, [response]);

  // ** document title
  document.title = `${t("site_name")} - ${t("home")}`;

  return (
    <>
      <section className="section pt-0">
        <Container fluid>
          <CarouselBanner
            slides={[
              {
                imgSrc: require("@imgs/banners/home-page-banner.jpg").default,
                title: t("home_page_banner_title"),
                action: (
                  <div className="d-grid gap-1 d-flex align-items-center justify-content-center justify-content-lg-start">
                    <Button.Ripple
                      className="me-50 p-1"
                      color="primary"
                      size="sm"
                      onClick={() => navigate("/dashboard")}
                    >
                      {t("already_have_solar")}
                    </Button.Ripple>
                    {!isUserHasSolar() && (
                      <Button.Ripple
                        className="p-1"
                        color="light"
                        size="sm"
                        outline
                        onClick={() =>
                          navigate("/user-profile", {
                            state: { activeTab: "3" },
                          })
                        }
                      >
                        {t("don't_have_solar")}
                      </Button.Ripple>
                    )}
                  </div>
                ),
              },
            ]}
            className="vh-100"
          />
        </Container>
      </section>

      <section className="py-5">
        <Container>
          <HowItWorks loading={loading} data={homeData.how_it_works} />
        </Container>
      </section>

      <section className="position-relative py-3 my-5 mt-lg-0">
        <Container fluid>
          <AppAd />
        </Container>
      </section>

      {homeData?.facebook_posts !== null &&
        homeData?.facebook_posts.length !== 0 && (
          <section className="pt-1 pb-3 mt-5 mt-lg-0">
            <Container>
              <FacebookPosts
                data={homeData?.facebook_posts}
                loading={loading}
              />
            </Container>
          </section>
        )}
    </>
  );
};

export default Home;
